import o from "./isFunction.js";
import e from "./_isMasked.js";
import a from "./isObject.js";
import s from "./_toSource.js";
var i = o, n = e, c = a, p = s, f = /[\\^$.*+?()[\]{}|]/g, u = /^\[object .+?Constructor\]$/, v = Function.prototype, m = Object.prototype, b = v.toString, g = m.hasOwnProperty, O = RegExp(
  "^" + b.call(g).replace(f, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function j(r) {
  if (!c(r) || n(r))
    return !1;
  var t = i(r) ? O : u;
  return t.test(p(r));
}
var h = j;
export {
  h as default
};
//# sourceMappingURL=_baseIsNative.js.map
